import { Coordinates } from "./coordinates.model";

export class MapConfig{
    coordinates: Coordinates;
    zoom: number;

    constructor(zoom: number);
    constructor(zoom: number, coordinates: Coordinates);
    constructor(zoom: number, coordinates?: Coordinates) {
        this.zoom = zoom;
        this.coordinates = coordinates ?? { latitude: 0, longitude: 0 };
    }
}